// extracted by mini-css-extract-plugin
export default {"ViewIncomeAndExpensePage":"ViewIncomeAndExpensePage_ViewIncomeAndExpensePage__oEIYK","divider":"ViewIncomeAndExpensePage_divider__3WzJP"};